import { OptionDescription } from './option.type';
import { EIndustryExam } from '../enums/industry-exam.enum';

export type IndustryExamRecord = Record<EIndustryExam, OptionDescription<EIndustryExam>>;
